import {CommonLinks} from "./link.constants";

function getContactSupportLink(subject: string = 'Something went wrong'): string {
  const params = `?subject=${subject}`;

  return `${CommonLinks.ContactSupport}${params}`;
}

export { getContactSupportLink };
